import _ from 'underscore';

function getPreferenceDataObj(preference, preferenceName) {
  const preferenceObj = preference.findByNameAtAccountLevel(preferenceName);

  return _.get(preferenceObj, 'Data');
}

export function getPreferenceForDashboard({ preference, preferenceName, dashboardPreferenceKey }) {
  const preferenceDataObj = getPreferenceDataObj(preference, preferenceName);

  if (_.has(preferenceDataObj, dashboardPreferenceKey)) {
    return preferenceDataObj[dashboardPreferenceKey];
  }

  return null;
}

function getCardPreference(dashboardPreferenceObj, cardId) {
  if (dashboardPreferenceObj && _.has(dashboardPreferenceObj, 'cards')) {
    const cardPref = _.find(dashboardPreferenceObj.cards, card => card.id === cardId);
    return cardPref;
  }

  return null;
}

export function getCardPreferenceOptions(dashboardPreferenceObj, cardId) {
  const cardPreference = getCardPreference(dashboardPreferenceObj, cardId);

  return _.get(cardPreference, 'options');
}

export function setPreferenceForCard({
  preference,
  preferenceName,
  dashboardPreferenceKey,
  cardId,
  cardOptions,
}) {
  const preferenceForDashboard = getPreferenceForDashboard({ preference, preferenceName, dashboardPreferenceKey });
  const preferenceForCard = getCardPreference(preferenceForDashboard, cardId);
  const cards = _.get(preferenceForDashboard, 'cards', []);
  let newCards = [];

  if (!preferenceForCard) {
    newCards = [...cards, { id: cardId, options: cardOptions }];
  } else {
    newCards = _.map(cards, (card) => {
      if (card.id === cardId) {
        return {
          ...card,
          options: cardOptions,
        };
      }

      return card;
    });
  }

  const newPreferenceForDashboard = {
    ...preferenceForDashboard,
    cards: newCards,
  };

  const preferenceDataObj = getPreferenceDataObj(preference, preferenceName);

  const newPreferenceDataObj = {
    ...preferenceDataObj,
    [dashboardPreferenceKey]: newPreferenceForDashboard,
  };

  preference.setAtAccountLevel({
    Data: newPreferenceDataObj,
    Name: preferenceName,
  });
}
